import React, { useEffect, useState } from 'react';
import { Box, TableCell, Typography } from '@mui/material';
import { ContatoInterno } from '../../services/api/contatos';
import { ContatoTable } from './contatoEmergencialTable';
import { ErrorOnDialog } from '../modals';
import { RequestError, useApi, Paginated } from '../../services';
import { formatBrazilianPhone } from '../../core';

interface Props {
  omitTitle?: boolean;
  idBarragem: number;
}

export const ContatosInternosPage: React.FC<Props> = ({ omitTitle, idBarragem }) => {
  const api = useApi();

  const [error, setError] = useState<RequestError>();
  const [paginate, setPaginate] = useState<Paginated<ContatoInterno>>({
    items: [],
    page: 1,
    perPage: 25,
    totalItems: 1,
    totalPages: 1,
  });

  useEffect(() => {
    api.contato.getContatosInternos(idBarragem, paginate.page, paginate.perPage).then(value => {
      if ("error" in value) {
        setError(value);
        return;
      }

      setPaginate(value);
    });
  }, [idBarragem, paginate.page, paginate.perPage]);

  return (<>
    <ErrorOnDialog
      open={Boolean(error)}
      error={error?.error ?? ""}
      message={error?.message ?? ""}
      onClose={() => setError(undefined)}
    />

    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      {!(omitTitle ?? false) && <Typography variant="h5" mb={2}>Contatos Internos</Typography>}

      <Box sx={{ height: `calc(100%${omitTitle ? "" : " - 40px"})`, display: "flex" }}>
        <ContatoTable<ContatoInterno>
          data={paginate.items}
          totalItems={paginate.totalItems}
          page={paginate.page - 1}
          perPage={paginate.perPage}
          onPageChange={(page) => setPaginate({ ...paginate, page: page + 1 })}
          onPerPageChange={(perPage) => setPaginate({ ...paginate, perPage: perPage })}
          showAcoes={false}
          renderCabecalho={() => (
            <>
              <TableCell>Função</TableCell>
              <TableCell>Setor</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Telefones</TableCell>
              <TableCell>E-mail</TableCell>
            </>
          )}
          renderColunas={(c) => (
            <>
              <TableCell>{c.funcao}</TableCell>
              <TableCell>{c.setor}</TableCell>
              <TableCell>{c.nome}</TableCell>
              <TableCell>{formatBrazilianPhone(c.telefones)}</TableCell>
              <TableCell>{c.email}</TableCell>
            </>
          )}
        />
      </Box>
    </Box>
  </>
  );
};